import React from 'react'
import { WinningIcon } from '../Winning/WinningIcon'
import type { Gain } from 'shared/store/tu-preferes-king/types'
import type { WinningType } from '../../../types'
import styled from 'styled-components'

export const ModalCover = (props: { winning: Gain, selected: WinningType }) => {
    return (
        <StyledCover>
            <WinningIcon
                type={props.selected}
                winning={props.winning}
                selected
            />
        </StyledCover>
    )
}

const StyledCover = styled.div`
    display: flex;
    position: relative;
    align-content: center;
    justify-content: center;
    width: 70%;
`
